// extracted by mini-css-extract-plugin
var _1 = "sale-_wi79";
export { _1 as "sale" }
